import { z } from 'zod';

export const generateSocialVideoResponseSchema = z.object({
  accepted: z.boolean(),
  socialVideoId: z.number(),
});

export type IGenerateSocialVideoResponse = z.infer<typeof generateSocialVideoResponseSchema>;
